import { computed } from "vue";
import {
  useGetAppOfferTriggersQuery,
  useCreateAppOfferTriggerMutation,
  useDeleteAppOfferTriggerMutation,
} from "@/graphql";

import useToast from "@/hooks/useToastNotification";

const { toastSuccess } = useToast();

export function useTriggers(appId: string) {
  const {
    result: queryResult,
    loading: queryLoading,
    refetch,
  } = useGetAppOfferTriggersQuery({
    appId,
  });

  const triggers = computed(() => queryResult.value?.getAppOfferTriggers || []);

  const { mutate: createTrigger, loading: createLoading } = useCreateAppOfferTriggerMutation({});

  const addTrigger = async (name: string) => {
    try {
      const createdTrigger = await createTrigger({ appId, name });
      await refetch();
      return createdTrigger?.data?.createAppOfferTrigger;
    } catch (error) {
      console.error("Error creating trigger:", error);
      return null;
    }
  };

  const { mutate: deleteTrigger, loading: deleteLoading } = useDeleteAppOfferTriggerMutation({});

  const removeTrigger = async (triggerId: string) => {
    try {
      await deleteTrigger({ appId, triggerId });
      toastSuccess({
        detail: `Trigger ${triggerId} deleted successfully.`,
        life: 3 * 1000,
        summary: "Success",
      });
      await refetch();
    } catch (error) {
      console.error("Error deleting trigger:", error);
    }
  };

  const overallLoading = computed(() => queryLoading.value || createLoading.value || deleteLoading.value);

  return { triggers, addTrigger, removeTrigger, overallLoading };
}
